"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_TYPE = exports.TERMS_AND_CONDITIONS_TRANSLATION = exports.CHINA_TERMS_AND_CONDITIONS_TRANSLATION = exports.CHECKBOX_STYLE = void 0;
var TERMS_AND_CONDITIONS_TRANSLATION = {
  headerTitle: "Terms & Conditions",
  termsText: // eslint-disable-next-line max-len
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra, sed ut senectus massa morbi enim, tincidunt ac ultricies. Risus, sodales malesuada diam tellus interdum enim auctor. Eget integer elementum ultrices nisl phasellus tortor pellentesque. Venenatis consequat erat ac fringilla amet amet etiam fermentum platea.'
};
exports.TERMS_AND_CONDITIONS_TRANSLATION = TERMS_AND_CONDITIONS_TRANSLATION;
var CHINA_TERMS_AND_CONDITIONS_TRANSLATION = [{
  termsText: // eslint-disable-next-line max-len
  'By clicking this box, you confirm that you understand and accept Airasia <a class="text-danger" target="_blank" href="{0}">Terms and Condition of Carriage</a>, <a class="text-danger"  target="_blank" href="{1}">Fare Rules</a>, <a class="text-danger" target="_blank" href="{2}">Terms of Use</a>, <a class="text-danger" target="_blank" href="{3}">Privacy Statement</a>, <a class="text-danger" target="_blank" href="{4}">@Checkout terms and conditions</a> and <a class="text-danger" target="_blank" href="{5}">other policies</a>',
  termsLinks: ['https://www.airasia.cn/aa/about-us/en/gb/terms-and-conditions.html#flights', 'https://www.airasia.cn/aa/about-us/en/gb/fares.html', 'https://www.airasia.cn/aa/about-us/en/gb/terms-of-use.html', 'https://www.airasia.cn/aa/about-us/en/gb/privacy-statement-cn.html', 'https://www.airasia.cn/aa/about-us/en/gb/one-click-terms-and-conditions.html', 'https://www.airasia.cn/aa/about-us/en/gb/our-policies.html']
}, {
  termsText: // eslint-disable-next-line max-len
  'By clicking this box, you confirm that you understand and accept that your sensitive personal data will be processed by Move Travel Sdn for the purpose of providing products and services.'
}, {
  termsText: // eslint-disable-next-line max-len
  'By clicking this box, you confirm that your personal information will be provided to Move Travel Sdn Bhd to its affliciates '
}];
exports.CHINA_TERMS_AND_CONDITIONS_TRANSLATION = CHINA_TERMS_AND_CONDITIONS_TRANSLATION;
var TEXT_TYPE = {
  title: {
    type: 'sub',
    size: 'small',
    color: 'greyDarker'
  },
  body: {
    type: 'small',
    size: 'XSmall',
    color: 'greyDark'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var CHECKBOX_STYLE = {
  boderColor: {
    unselected: 'fireRed',
    selected: 'greyLight'
  }
};
exports.CHECKBOX_STYLE = CHECKBOX_STYLE;